export enum TemplateEnumType{
    LISTTEMPLATE,
    EDITTEMPLATE,
    CREATETEMPLATE,
    VIEWTEMPLATE,
    SUBSCRIBE,
    VIEWSUBSCRITION,
    MODIFYSUBSCRIBE,
}

interface IGetCorpsSprayResModel {
    lstSpray: {
            date: string,
            originDate?: string;
            name: string,
            lstHourData: {
                    hour: string,
                    srl: string,
                    backColor: string,
            }[]
    }[]
}

interface IGetStressAlertResModel {
    requestLatitude?: number;
    requestLongitude?: number;
    modelName?: string;
    date?: string;
    property?: string;
    value?: string;
}
interface IGetPlantingdDataResModel{
    cropCode?: string;
    cropName?: string;
    code?: number;
    aggregation?: string;
    unit?: string;
    level?: string;
    date?: string[];
    originDate?: string[];
    values?: string[][];
    recommendationValus?: string[][]
    weeks?: {
        weekName?: string,
        weekIndex?: number
    }[]
    requestBody?: string;
    backColors?: string[][]
}
interface IGetDiseaseRiskDataResModel{
    cropName?: string;
    modelName?: string;
    modelId?: string;
    code?: number;
    aggregation?: string;
    unit?: string;
    level?: string;
    date?: string[];
    originDate?: string[];
    values?: string[];
    weeks?: {
        weekName?: string,
        weekIndex?: number
    }[]
    requestBody?: string;
    backColors?: string[]
    // hourly
    hourlyDates?: string[]
    hourlyValues?: string[][]
    hourlyBackColors?: string[][]
}
interface IGetPhytophagyStressRiskDataResModel{
    cropCode?: string;
    cropName?: string;
    date?: string[];
    originDate?: string[];
    finalDate?: string[];
    recommendationValues?: string[][]
    finalRecommendationValues?: string[]
    type?: string[]
    values?: string[][]
    requestBody?: string;
    backColors?: string[][]
    finalBackColors?: string[]
}
interface IGetStressAlertDataResModel{
    cropName?: string;
    modelName?: string;
    modelId?: string;
    code?: number;
    aggregation?: string;
    unit?: string;
    level?: string;
    date?: string[];
    originDate?: string;
    values?: string[];
    weeks?: {
        weekName?: string,
        weekIndex?: number
    }[]
    requestBody?: string;
    backColors?: string[]
}
interface IGetHistoricalOrForecastDataResModel{
    variable?: string;
    code?: number;
    aggregation?: string;
    unit?: string;
    level?: string;
    date?: string[];
    originDate?: string[];
    values?: string[];
    weeks?: {
        weekName?: string,
        weekIndex?: number
    }[]
    requestBody?: string;
    // for hourly
    hourlyValues?: string[][]
    // add by self
    fontSize?: number;
}

interface IAgriAlertBasicTranslateModel{
    // forecast
    'historical_chart'?: string;
    'forecast_chart'?: string;
    'forecast_table'?: string;
    'variables'?: string;
    'temperature_daily_max'?: string;
    'temperature_daily_min'?: string;
    'temperature_daily_average'?: string;

    'temperature_8hourly_max'?: string;
    'temperature_8hourly_min'?: string;
    'temperature_8hourly_average'?: string;

    'relative_humidity'?: string;
    'precipitation'?: string;
    'wind_speed'?:string;
    'soil_temperature'?: string;
    'soil_moilsture'?: string;
    'wind_gust'?: string;
    'location'?: string;
    'spray_window'?: string;
    'speed'?: string;
    'temperature'?: string;
    // color legend
    'color_legend'?: string;
    'recommended'?: string;
    'limited'?: string;
    'not_advisable'?: string;
    // week and month
    'mon'?: string;
    'tue'?: string;
    'wed'?: string;
    'thu'?: string;
    'fri'?: string;
    'sat'?: string;
    'sun'?: string;
    'jan'?: string;
    'feb'?: string;
    'mar'?: string;
    'apr'?: string;
    'may'?: string;
    'jun'?: string;
    'jul'?: string;
    'aug'?: string;
    'sep'?: string;
    'oct'?: string;
    'nov'?: string;
    'dec'?: string;
    // short month2
    'jan_short'?: string;
    'feb_short'?: string;
    'mar_short'?: string;
    'apr_short'?: string;
    'may_short'?: string;
    'jun_short'?: string;
    'jul_short'?: string;
    'aug_short'?: string;
    'sep_short'?: string;
    'oct_short'?: string;
    'nov_short'?: string;
    'dec_short'?: string;
    // Restrictions legned
    'hours_of_the_day'?: string;
    'restrictions_legend'?: string;
    'left_surface_too_wet'?: string;
    'temperature_too_high'?: string;
    'evaporation_risk'?: string;
    'rain'?: string;
    'temperature_too_low'?: string;
    'risk_of_wind'?: string;
    'windy'?: string;
    'multiple_risks'?: string;
    'humidity_too_low'?: string;
    // other
    'close'?: string;
    // spray variables
    'sw_aerialspraygeneric'?: string;
    'sw_groundspraygeneric'?: string;
    'sw_ground_frcp01'?: string;
    'sw_aerialspray_aus'?: string;
    'sw_groundspray_aus'?: string;
    'sw_groundsprayvineandtree'?: string;
    'sw_groundsprayherbicide_pe'?: string;
    'sw_groundsprayfungicide'?: string;
    'sw_groundsprayherbicide_ld'?: string;
    'sw_groundsprayherbicide_sd'?: string;
    'SW_Vixeranbiostim'?: string;
    'SW_Ground_HLFM'?: string;
    'nutribion_application_timing'?: string;
    [key:string]: string;
    'footer_copyright'?: string;
    'footer_service'?: string;
    'footer_meteoblue'?: string;
    'footer_data'?: string;
    'footer_content'?: string;
    'footer_click_content'?: string;
    'footer_here'?: string;
    'footer_unsubscribe'?: string;
    'footer_edit': string;
    'footer_options': string;
    'footer_mandatory': string;
    // new variables for historical and forecast
    'cloud_cover': string;
    'wind_direction': string;
    'radiation': string;
    'dewpoint': string;
    'air_pressure': string;
    'growing_degree_days': string;
    'precipitation_risk': string;
    'shower_risk': string;
    'thunderstorm_risk': string;
    'percentage': string;
    'par': string;
    'air_temperature': string;
    'daily': string;
    'hourly': string;
    'resolution': string;
    'forecast': string;
    'historical': string;
    'and'?: string;
    'table': string;
    'forecast_hourly_table': string;
    'forecast_daily_table': string;
    'forecast_8hourly_table': string;

    'forecast_daily_chart': string;
    'forecast_8hourly_chart': string;
    'forecast_hourly_chart': string;
    'no_wind': string;
    'storm': string;
    'wind_image': string;
    'weather_image': string;
}

interface IAgronomicTranslateModel {
    // 基础部分
    'Apples'?: string;
    'Cereal'?: string;
    'Corn'?: string;
    'Grapes'?: string;
    'Pepper'?: string;
    'Potato'?: string;
    'Sunflower'?: string;
    'Turf'?: string;

    'no_risk'?: string;
    'low_risk'?: string;
    'medium_risk'?: string;
    'high_risk'?: string;
    'very_high_risk'?: string;


    // planting部分
    'PW_Corn_RU'?: string;
    'PW_Spring_Barely'?: string;
    'PW_Spring_Wheat'?: string;
    'PW_Winter_Wheat'?: string;
    'PW_Sunflower'?: string;
    'PW_Soybean'?: string;
    'PW_OSR'?: string;
    'PW_Canola'?: string;
    'PW_SugarBeet'?: string;
    'PW_Tomato'?: string;
    'PW_Corn_FR'?: string;
    'PW_Sunflower_FR'?: string;
    'resLegTooLoSoilTemp'?: string;
    'resLegTooLoTemp'?: string;
    'resLegPrecipitation'?: string;
    'resRainExpected'?: string;
    'resLegSoilTooWet'?: string;
    'multiple'?: string;
    'resPastPrecipitation'?: string;
    'resPrecipitationExpected'?: string;

    // disease risk部分
    'AppleBlossomFireBlightErwiniaamylovora'?: string;
    'AppleScabFusicladiumVenturiainaequalis'?: string;
    'BarleyNetBlotchPyrenophoraTeres'?: string;
    'BarleyNetBlotchPyrenophoraTeres_RU'?: string;
    'CanolaBlacklegLeptosphaeriamaculans'?: string;
    'CanolaBlacklegLeptosphaeriamaculans_RU'?: string;
    'CanolaSclerotiniaApothecia'?: string;
    'CanolaSclerotiniaApothecia_RU'?: string;
    'CanolaSclerotiniaInfection'?: string;
    'CanolaSclerotiniaInfection_RU'?: string;
    'CanolaWhiteLeafSpotPseudocercosporellacapsellae'?: string;
    'CeralPseudocercosporellaherpotrichoides_RU'?: string;
    'CerealLeafBrownRustPucciniahordei_RU'?: string;
    'CerealLeafBrownRustPucciniarecondita'?: string;
    'CerealLeafBrownRustPucciniarecondita_RU'?: string;
    'CerealPowderyMildewEryspihegraminis'?: string;
    'CerealPowderyMildewEryspihegraminis_PL'?: string;
    'CerealPowderyMildewEryspihegraminis_RU'?: string;
    'CerealSeptoriaLeafGlumeBlotchStagonosporaNodorum'?: string;
    'CerealSeptoriaLeafGlumeBlotchStagonosporaNodorum_RU'?: string;
    'CerealSeptoriaTriticiLeafBlotchSpot'?: string;
    'CerealYellowStripeRustPucciniastriiformis'?: string;
    'CerealYellowStripeRustPucciniastriiformis_RU'?: string;
    'OatsCrownRustPucciniaCoronata'?: string;
    'OatsCrownRustPucciniaCoronata_RU'?: string;
    'WheatBlackStemRustPucciniagraminis'?: string;
    'WheatBlackStemRustPucciniagraminis_RU'?: string;
    'WheatFusariumHeadBlight'?: string;
    'WheatFusariumHeadBlight_RU'?: string;
    'WheatKarnalPartialBuntTilletiaindicavar'?: string;
    'WheatPyrenophraTriticiRepentis_RU'?: string;
    'WheatSeptoriaLeafBlotchRisk'?: string;
    'WheatSeptoriaLeafBlotchRisk_RU'?: string;
    'CornFusariumHeadBlight'?: string;
    'CornGrayLeafSpot'?: string;
    'CornGrayLeafSpot_US'?: string;
    'CornNortherncornleafblightNCLB'?: string;
    'CornNortherncornleafblightNCLB_RU'?: string;
    'CornNortherncornleafblight_US'?: string;
    'CornSoutherncornleafblightSCLB'?: string;
    'TarSpot'?: string;
    'TarSpot_US'?: string;
    'GrapesAnthracnoseblackspot'?: string;
    'GrapesBotrytiscinerea'?: string;
    'GrapesDownyMildewPlasmoparaviticola'?: string;
    'GrapesPowderyMildewUncinulanecator'?: string;
    'HotPepperAculopslycopersici'?: string;
    'HotPepperAnthracnose'?: string;
    'HotPepperAphisgossypii'?: string;
    'HotPepperAtheliaRolfsii'?: string;
    'HotPepperBemisiatebasi'?: string;
    'HotPepperChilLeaf'?: string;
    'HotPepperColletotrichumcapsici'?: string;
    'HotPepperFusariumoxysporum'?: string;
    'HotPepperHelicoverpaarmigeraSpodopteralitura'?: string;
    'HotPepperLeveillulataurica'?: string;
    'HotPepperPhytophoracapsici'?: string;
    'HotPepperThripstebasi'?: string;
    'Bruchid'?: string;
    'ConventionalSmithBlight'?: string;
    'EarlyBlight'?: string;
    'FrostAlert'?: string;
    'HeatStress'?: string;
    'HuttonBlight'?: string;
    'PotatoAlternariasolani'?: string;
    'PotatoBotrytiscinerea'?: string;
    'PotatoEarlyBlightAlternariasolani'?: string;
    'PotatoEarlyBightAlternariasolani_PL'?: string;
    'PotatoLateBlightPhytophthorainfestans'?: string;
    'PotatoPhytophotraInfestans'?: string;
    'PotatoPhytophotraInfestans_RU'?: string;
    'PotatoSclerotiniarotSclerotiniasclerotiorum'?: string;
    'PotatoSclerotiniawiltSclerotiniarolfsii'?: string;
    'PotatoSilverscurfHelminthosporiumsolani'?: string;
    'PotatoVerticilliumWiltVerticilliumdahliae'?: string;
    'SunflowerRustAeciospore'?: string;
    'SunflowerRustUrediniospore'?: string;
    'AnthracnoseFoliarBlight'?: string;
    'BrownPatchRiskIrrigated'?: string;
    'BrownPatchRiskNonIrrigated'?: string;
    'CrabgrassGerminationRisk'?: string;
    'DollarSpotRiskIrrigated'?: string;
    'DollarSpotRiskNonIrrigated'?: string;
    'DollarSpotSmithModelRisk'?: string;
    'FusariumPatchHighRisk'?: string;
    'FusariumPatchRisk'?: string;
    'GrayLeafSpot'?: string;
    'PoaAnnuaGerminationRisk'?: string;
    'PoaAnnuaSeedheadsRisk'?: string;
    'PythiumBlightRiskIrrigated'?: string;
    'PythiumBlightRiskNonIrrigated'?: string;
    'PythiumRootRotRisk'?: string;
    'RustRisk'?: string;
    'TakeAllPatchRiskIrrigated'?: string;
    'TakeAllPatchRiskNonIrrigated'?: string;
    'disease_risk'?: string;
    'planting_recommendation'?: string;
    'planting_legend'?: string;
    'stress_alert'?: string;


    'stress'?: string;
    'no_stress'?: string;


    'heat_stress'?: string;
    'cold_stress'?: string;
    'thermal_stress'?: string;
    'low'?: string;
    'med'?: string;
    'high'?: string;
    'heat_stress_desc'?: string;
    'cold_stress_desc'?: string;

    'phytophagy_stress'?: string;
    'heat_stress_risk'?: string;
    'cold_stress_risk'?: string;
    'AS_Corn'?: string;
    'AS_Potatoes'?: string;
    'AS_WinterCereals'?: string;
    'AS_Sunflower'?: string;
    'AS_Canola'?: string;
    'AS_Grapes'?: string;
    // 可添加其他需要的通用兜底属性
    [key: string]: string;
}

interface IAgriAlertTranslateResModel extends IAgriAlertBasicTranslateModel,IAgronomicTranslateModel{

}
interface IAgriAlertTranslateModel{
    languageCode: string;
    translateValues: IAgriAlertTranslateResModel;
}

export type{
    IGetCorpsSprayResModel,
    IGetHistoricalOrForecastDataResModel,
    IAgriAlertTranslateResModel,
    IAgriAlertTranslateModel,
    IGetPlantingdDataResModel,
    IGetDiseaseRiskDataResModel,
    IGetStressAlertResModel,
    IGetStressAlertDataResModel,
    IGetPhytophagyStressRiskDataResModel
};